import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Wrapper = styled(motion.div)(({ theme }) => ({
  flex: 1,
  width: '100%',
  background: theme.background,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  paddingTop: 112,
}));
